import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { TPVOrderData } from './types'
import { baseCalculateParams, totalCalculateParams } from '@teinor/erp/prices/quote/calculate'

export const handleSellTicketRefundData = (tableData: TPVOrderData['tableData']) => {
    const uniquesRefund: TwinDictionary = {}
    const refundedUniques = []
    for (const element of tableData) {
        if (element.refundQuantity) {
            for (const refund of element.refundQuantity) {
                if (refund.unique_number) {
                    for (const unique of refund.unique_number) {
                        refundedUniques.push(unique.serialCode)
                    }
                }
            }
            const restRefundQuantity = roundNumberAndDecimals(parseFloat(element.quantity) - element.quantityRefunded, totalCalculateParams)
            element['restRefundQuantity'] = restRefundQuantity
            element['quantity'] = restRefundQuantity
            element['quantity2'] = roundNumberAndDecimals(restRefundQuantity * element.quantity2base, totalCalculateParams)
            element['totalRefund'] = restRefundQuantity > 0 ? false : true
        } else {
            element['restRefundQuantity'] = element.quantity
            element['totalRefund'] = false 
        }
        if (element.unique_number) {
            for (const myUniques of element.unique_number) {
                if (!refundedUniques.length || !refundedUniques.includes(myUniques.serialCode)) {
                    if (!uniquesRefund?.[element.id]) {
                        uniquesRefund[element.id] = []
                    }
                    uniquesRefund[element.id].push(myUniques)
                }
            }
        }
        element['returnStock'] = true
        element.unique_number = uniquesRefund[element.id]
        element.unique_number_selected = []
        element.WarehouseId = null
        handleSellTicketRefundDiscounts(element)
    }
    return tableData
}

const handleSellTicketRefundDiscounts = (element: TwinDictionary) => {
    if (element.extraLineDiscount) {
        let myDiscount = parseFloat(String(element.extraLineDiscountWithTax))
        const unityLineDiscount = roundNumberAndDecimals(myDiscount / parseFloat(String(element.desiredQuantity)), baseCalculateParams)
        element.discount = unityLineDiscount
        element.typeDiscount = 2
    }
    return element
}

export const parseSellTicketRefundConflicts = (data: TPVOrderData) => {
    let conflicts: TwinDictionary = {}
    for (const element of data.selectedTableData || data.tableData) {
        const myPos = data.dictPosTableData[element.id]
        const myElement = data.tableData[myPos]
        if (myElement.unique_number && (parseFloat(myElement.quantity) !== parseFloat(myElement.restRefundQuantity))) {
            if (!conflicts['unique_numbers']) {
                conflicts['unique_numbers'] = {}
            }
            conflicts['unique_numbers'][element.id] = { name: myElement.name, quantity: myElement.quantity, elements: myElement.unique_number }
        }
    }
    if (data.header.warehouse_conflicts) {
        conflicts['warehouses'] = data.header.warehouse_conflicts
    }
    if (!Object.keys(conflicts)?.length) {
        return null
    }
    return conflicts
}